import type { components } from "@/api-schema";
import type { RowWithIdentifier } from "@/components/data-table/_helpers/row-identifier";
import type { ImplementedColumnDef } from "@/components/data-table/types";
import { casaviContactBlacklistTableDefaultColumns } from "@/components/data-table/predefined/casavi-contact-blacklist-table-columns";
import { casaviContactWhitelistTableDefaultColumns } from "@/components/data-table/predefined/casavi-contact-whitelist-table-columns";

type CasaviContactWhitelist = components["schemas"]["CasaviContactWhitelist"] & RowWithIdentifier;
type CasaviContactBlacklist = components["schemas"]["CasaviContactBlacklist"] & RowWithIdentifier;

/**
 * Returns the default column configuration for Casavi Contact Whitelist table
 */
export function getCasaviContactWhitelistColumns(): ImplementedColumnDef<CasaviContactWhitelist, unknown>[] {
  return [
    casaviContactWhitelistTableDefaultColumns.columnElement,
    casaviContactWhitelistTableDefaultColumns.columnType,
    casaviContactWhitelistTableDefaultColumns.columnValue,
    casaviContactWhitelistTableDefaultColumns.columnCaseSensitive,
  ] as ImplementedColumnDef<CasaviContactWhitelist, unknown>[];
}

/**
 * Returns the default column configuration for Casavi Contact Blacklist table
 */
export function getCasaviContactBlacklistColumns(): ImplementedColumnDef<CasaviContactBlacklist, unknown>[] {
  return [
    casaviContactBlacklistTableDefaultColumns.columnElement,
    casaviContactBlacklistTableDefaultColumns.columnType,
    casaviContactBlacklistTableDefaultColumns.columnValue,
    casaviContactBlacklistTableDefaultColumns.columnCaseSensitive,
  ] as ImplementedColumnDef<CasaviContactBlacklist, unknown>[];
}
